import IconCheckCircle from '@spothero/icons/checkmark-circle-filled';
import IconCircleSlash from '@spothero/icons/circle-slash';
export const EMPLOYEE_GROUP_STATUSES = {
    ACTIVE: 'ACTIVE',
    DISABLED: 'DISABLED',
    EXPIRED: 'EXPIRED',
} as const;

export const EMPLOYEE_GROUP_STATUS_ORDERED = [
    EMPLOYEE_GROUP_STATUSES.ACTIVE,
    EMPLOYEE_GROUP_STATUSES.EXPIRED,
    EMPLOYEE_GROUP_STATUSES.DISABLED,
] as const;

export const EMPLOYEE_GROUP_VISIBILITY = {
    PUBLIC: {label: 'Public', value: 'public'},
    PRIVATE: {label: 'Private', value: 'private'},
} as const;

export const EMPLOYEE_GROUP_MEMBER_STATUSES = {
    PENDING: 'pending',
    ACTIVE: 'active',
    REVOKED: 'revoked',
} as const;

export const STEP_STATUSES = {
    NEUTRAL: 'neutral',
    ERROR: 'error',
    COMPLETE: 'complete',
} as const;

export const WIZARD_STEP_IDS = {
    facilityStep: 'facilityStep',
    eventStep: 'eventStep',
    rateStep: 'rateStep',
    shareStep: 'shareStep',
    title: 'title',
} as const;

export const GROUP_BADGE_STATUS = {
    ACTIVE: {
        label: 'Live',
        value: EMPLOYEE_GROUP_STATUSES.ACTIVE,
        color: 'green.100',
        icon: IconCheckCircle,
        iconColor: 'green',
        description: 'Employees can book parking.',
    },
    DISABLED: {
        label: 'Off',
        value: EMPLOYEE_GROUP_STATUSES.DISABLED,
        color: 'gray.100',
        icon: IconCircleSlash,
        iconColor: 'red',
        description: 'New bookings are not permitted',
    },
    EXPIRED: {
        label: 'Expired',
        value: EMPLOYEE_GROUP_STATUSES.EXPIRED,
        color: 'gray.100',
        icon: IconCircleSlash,
        iconColor: 'error',
        description:
            'All events have passed, so booking is no longer available.',
    },
};
